'use client';
import { useContext, useEffect, useRef, useState } from 'react';

import { OnBoardingItem } from '../onBoardingItem/onBoardingItem';
import { ThemeContext } from '@susu/custom-made/providers';
import Avo from '@susu/custom-made/Avo';
import { getAvoEventParams } from '@susu/custom-made/utils/utils';

export const OnBoardingPanel = ({
  title,
  ctaText,
  stepAmount,
  ctaClick,
}: {
  title: string[];
  ctaText: string;
  stepAmount: number;
  ctaClick: () => void;
}) => {
  const { state } = useContext(ThemeContext);
  const [currentStep, setCurrentStep] = useState<number>(0);
  const [animationDone, setAnimationDone] = useState<boolean>(false);
  const firstItemInterval = useRef<NodeJS.Timeout>();
  const firstItemIntervalTime = 2000;
  const restItemsInterval = useRef<NodeJS.Timeout>();
  const restItemsIntervalTime = 6000;

  const startFirstItemInterval = () => {
    firstItemInterval.current = setInterval(() => {
      setCurrentStep(1);
    }, firstItemIntervalTime);
  };

  const startRestItemsInterval = () => {
    restItemsInterval.current = setInterval(() => {
      setCurrentStep(step => step + 1);
    }, restItemsIntervalTime);
  };

  const changeStepClick = (step: number) => {
    setAnimationDone(true);
    setCurrentStep(step);
    clearInterval(firstItemInterval.current);
    clearInterval(restItemsInterval.current);
  };

  useEffect(() => {
    if (currentStep >= stepAmount - 1) {
      clearInterval(restItemsInterval.current);
      setTimeout(() => {
        setAnimationDone(true);
      }, restItemsIntervalTime);
    }

    if (currentStep === 0 && !firstItemInterval.current) {
      startFirstItemInterval();
    }

    if (currentStep === 1 && firstItemInterval.current && !restItemsInterval.current) {
      clearInterval(firstItemInterval.current);
      startRestItemsInterval();
    }

    switch (currentStep) {
      case 0:
        Avo.overlayIntroShowed(getAvoEventParams(state));
        break;
      case 1:
        Avo.overlayFabricShowed(getAvoEventParams(state));
        break;
      case 2:
        Avo.overlayStyleShowed(getAvoEventParams(state));
        break;
      case 3:
        Avo.overlayPersonaliseShowed(getAvoEventParams(state));
        break;
      case 4:
        Avo.overlayFitShowed(getAvoEventParams(state));
        break;
    }
  }, [currentStep, setCurrentStep]);

  return (
    <OnBoardingItem
      titles={title}
      ctaText={ctaText}
      stepAmount={stepAmount}
      currentStep={currentStep}
      ctaClick={ctaClick}
      changeStepClick={changeStepClick}
      animationDone={animationDone}
    />
  );
};
